import { cva } from "cva";

export const expandingMenuStyles = cva({
  base: "flex flex-col bg-surface-1 border-b-1 border-border-decorative first:border-t-1",
});
